/**
 * Created on 2017/07/11.
 * Controller for 我的账户-账单和余额菜单的争议单
 */
define('controllers/myaccount/dispute/account-dispute.ctrl',['app', 'mainCons'], function (app, mainCons) {
    app.controller('AccountDisputeCtrl', ['$q', '$scope', '$state', 'auiDialog', 'UserInfo',  'OpenTrade', '$filter','myIncentiveService',
        function ($q, $scope, $state, auiDialog, UserInfo, OpenTrade, $filter,myIncentiveService) {
            /* 1. 局部变量声明 */

            var states = $state.current.name.split('.');
            var state = states[1];
            var billTypes = {
                newEarnings: 'AP',//应付-收益
                bills: 'AR' //应收-账单
            };

            var cancelingDisputeIDS=[];

            var Model = $scope.Model = {
                constant: mainCons.earningsConstant,
                constants: mainCons.settlementConstant,
                billType: billTypes[state],
                tagType: "dipute",
                cpName: UserInfo.get().realName,
                checked: {all: false},
                businessType: mainCons.settlementConstant.businessType[billTypes[state]]
            };

            //   分页
            Model.pagination = {
                currentPage: 1,// 当前页
                itemsPerPage: 10,// 默认每页个数
                totalCount: 0,
                pagesLength: 5,// 显示的页码数量,
                itemsPerPageBackUp: 10,
                noItems: "No products",
                onChange: $scope.goPage
            };
            // 保存勾选的争议单信息
            Model.disputeLists = [];

            /* 2. $scope变量声明 */

            $scope.$watch(function () {
                return Model.pagination.currentPage + "" + Model.pagination.itemsPerPage + "" + Model.pagination.totalCount;
            }, function () {
                $scope.goPage();
            });

            /* 3. $scope函数挂载 */


            // 重置筛选
            $scope.backup = backup;

            // 撤销争议
            $scope.disputeDetail =disputeDetail ;

            $scope.queryList = queryList;

            $scope.claerCheckAll = claerCheckAll;

            $scope.goPage = goPage;

            $scope.cancelDispute = cancelDispute;

            // 批量撤销
            $scope.cancelDisputeBatch = cancelDisputeBatch ;

            $scope.selectAll = selectAll ;

            //设置半选的状态
            $scope.checkHalf = checkHalf;

            $scope.getCkeckAbleLength=getCkeckAbleLength;

            $scope.selectSingle = selectSingle ;

            $scope.checkStatus = checkStatus;

            /* 4. 初始化函数声明与执行 */
            // 重置筛选
            $scope.backup();
            $scope.queryList();



            function selectSingle(bill, index,event,flag) {
                if(event) event.stopPropagation();
                if(flag) return;
                if (!Model.checked[index]) {
                    Model.checked[index] =true;
                    addEle(bill);
                    if (Model.disputeLists.length == getAvailableCount()) {
                        Model.checked['all'] = true;
                    }
                } else {
                    Model.checked[index] =false;
                    delEle(bill);
                    Model.checked['all'] = false;
                }
            }

            function cancelDisputeBatch() {

                if (Model.disputeLists && Model.disputeLists.length > 0) {
                    $scope.cancelDispute();
                } else {
                    auiDialog.warn('请至少选择一条争议单');
                }
            }

            function claerCheckAll() {
                Model.checked = {all: false};
                Model.disputeLists = [];
            }

            function queryList() {

                var defer = $q.defer();
                Model.disputeListAll = null;
                Model.disputeList = [];
                var params = {};
                params.billType = billTypes[state];
                if(Model.query.businessType.selected.typeCode!='-1'){
                    params.businessType = Model.query.businessType.selected.typeCode;
                    if(params.businessType == '4'){
                        params.businessType = "4,204";
                    } else if(params.businessType == '8'){
                        params.businessType = "8,208";
                    }
                }
                if(Model.timeQuarter.startTime){
                    params.disputeStartTime = getyyyymm(Model.timeQuarter.startTime).slice(0, 6);
                }else{
                    params.disputeStartTime = getyyyymm(Model.query.startTime).slice(0, 6);
                }
                if(Model.timeQuarter.endTime){
                    params.disputeEndTime = getyyyymm(Model.timeQuarter.endTime).slice(0, 6);
                }else{
                    params.disputeEndTime = getyyyymm(Model.query.endTime).slice(0, 6);
                }

                if (Model.query.billID) {
                    params.billID = Model.query.billID;
                }

                OpenTrade.getDispute({req: params}).then(function (resp) {

                    if (resp.retCode == 0) {
                        if (resp.result) {
                            Model.disputeListAll = resp.result;
                        }
                        else {
                            Model.disputeListAll = [];
                        }
                        Model.pagination.totalCount = Model.disputeListAll.length;
                        Model.pagination.currentPage = 1;
                        $scope.goPage();
                    }
                    defer.resolve();
                }).catch(function () {
                    Model.disputeListAll = [];
                    Model.disputeList=[];
                    Model.pagination.currentPage=1;
                    Model.pagination.totalCount=0;
                    defer.reject();
                });
                return defer.promise;
            }

            function checkStatus(status) {
                if (status == '0' || status == 'null') {
                    return false;
                }
                return true;
            }

            function selectAll(val,event,flag) {
                event.stopPropagation();
                if(flag) return;
                if (!Model.checked[val]) {
                    for (var i = 0, j = Model.disputeList.length; i < j; i++) {
                        if (!$scope.checkStatus(Model.disputeList[i].disputestatus)) {
                            Model.disputeLists.push(Model.disputeList[i]);
                            Model.checked[i] = true;
                        }
                    }
                    Model.checked[val] = true;
                }
                else {
                    for (var i1 = 0, j1 = Model.disputeList.length; i1 < j1; i1++) {
                        if (!$scope.checkStatus(Model.disputeList[i1].disputestatus)) {
                            Model.checked[i1] = false;
                        }
                    }
                    Model.disputeLists = [];
                    Model.checked[val] = false;
                }
            }

            function checkHalf() {
                var temp = 0;
                if (Model.disputeList && Model.disputeList.length > 0) {
                    var listLength = Model.disputeList.length;
                    for (var k = 0; k < listLength; k++) {
                        if (Model.checked[k] == true) {
                            temp++;
                        }
                    }
                }

                return temp != 0 && temp < getCkeckAbleLength();
            }

            // 争议详情
            function disputeDetail(dispute) {
                var url = billTypes[state] == 'AR' ? 'MyAccount.disputeBillsDetail' : 'MyAccount.disputeEarningsDetail';//
                var param={
                    disputeID: dispute.disputeID,
                    billID:dispute.billID,
                    disputestatus:dispute.disputestatus,
                    historyNodeInfos:dispute.historyNodeInfos
                };
                $state.go(url, {dispute:JSON.stringify(param) }, {reload: true});
            }

            // 撤销争议
            function cancelDispute(dispute) {
                var params=getCancelParams(dispute);
                if(paramsInCanceling(params,cancelingDisputeIDS)){
                    return;
                }
                var defer = $q.defer();
                auiDialog.confirm('确认要撤销争议吗？', function () {
                    cancelingDisputeIDS=getCancelParams(dispute);
                    OpenTrade.cancelDispute({req: params}).then(function (resp) {
                        if (resp.retCode == 0) {
                            params=getCancelParams(dispute);
                            params.disputeInfos.forEach(function (p) {
                                Model.disputeList.forEach(function (dispute,i) {
                                    if(p.disputeID ==dispute.disputeID){
                                        Model.disputeList[i].disputestatus=2;
                                    }
                                });
                            });
                            $scope.queryList();
                            cancelingDisputeIDS=[];
                            auiDialog.success('争议单撤销成功');
                            defer.resolve();
                        }
                    }).catch(function () {
                        cancelingDisputeIDS=[];
                        defer.reject();
                    });
                }, function(){
					cancelingDisputeIDS=[];
					defer.resolve();
				});
                return defer.promise;
            }

            function goPage() {
                $scope.claerCheckAll();
                var pageNum = Model.pagination.currentPage;
                var pageItem = Model.pagination.itemsPerPage;

                Model.pagination.totalCount = Model.disputeListAll?Model.disputeListAll.length:0;
                if (Model.pagination.totalCount  > 0) {
                    // 分页
                    if (Model.disputeListAll.length >= (pageNum) * pageItem) {
                        Model.disputeList = Model.disputeListAll.slice((pageNum - 1) * pageItem, (pageNum) * pageItem);
                    } else {
                        Model.disputeList = Model.disputeListAll.slice((pageNum - 1) * pageItem, Model.disputeListAll.length);
                    }
                } else {
                    Model.disputeList = [];
                }
            }

            // 重置筛选
            function backup() {
                Model.query = {
                    startTime: new Date(),
                    endTime: new Date(),
                    amxMonth: new Date(),
                    billID:"",
                    disputestatusMap: mainCons.settlementConstant.dispute,
                    businessType: {
                        selected: {typeCode: '-1', typeName: '全部'},
                        BusinessTypeList: []
                    }
                };

                mainCons.settlementConstant.businessSelector[billTypes[state]].forEach(function(data){
                    if(data.typeCode != '204' && data.typeCode != '208' && data.typeCode != '155' && data.typeCode != '156'&& data.typeCode != '157'&& data.typeCode != '158'){
                        Model.query.businessType.BusinessTypeList.push(data);
                    }
                });

                Model.timeQuarter = myIncentiveService.getTimeQuarter(5);
            }

            function paramsInCanceling(params,cancelingDisputeIDS){

                if(cancelingDisputeIDS.length<=0){
                    return false;
                }
               var inCanceling=false;
               params.disputeID.forEach(function (p) {
                   cancelingDisputeIDS.disputeID.forEach(function (p1) {
                        if(p==p1){
                            inCanceling=true;
                        }
                   });
               });
               return inCanceling;
            }

            function addEle(bill) {
                for (var i = 0, j = Model.disputeLists.length; i < j; i++) {
                    if (bill == Model.disputeLists[i]) {
                        return;
                    }
                }
                Model.disputeLists.push(bill);
            }

            function delEle(bill) {
                var temp = [];
                for (var i = 0, j = Model.disputeLists.length; i < j; i++) {
                    if (bill != Model.disputeLists[i]) {
                        temp.push(Model.disputeLists[i])
                    }
                }
                Model.disputeLists = temp;
            }

            function getAvailableCount() {
                var count = 0;
                for (var i = 0, j = Model.disputeList.length; i < j; i++) {
                    if (!$scope.checkStatus(Model.disputeList[i].disputestatus)) {
                        count++;
                    }
                }
                return count;
            }

            function getCkeckAbleLength() {
                var legth=0;
                if(!Model.disputeList){
                    return 0;
                }
                Model.disputeList.forEach(function (v) {
                    if(!$scope.checkStatus(v.disputestatus)){
                        legth+=1;
                    }
                });
                return legth;
            }

            //   封装撤销争议单，请求参数
            function getCancelParams(dispute) {
                var disputeIDs = [];

                if (dispute) {
                    // 单个撤销
                    disputeIDs.push({disputeID:dispute.disputeID,siteCode:dispute.siteCode});
                } else {
                    // 批量撤销
                    if (Model.disputeLists && Model.disputeLists.length > 0) {
                        Model.disputeLists.forEach(function (v) {
                            disputeIDs.push({disputeID:v.disputeID,siteCode:v.siteCode});
                        });
                    }
                }

                var params = {
                    disputeInfos: disputeIDs
                };

                return params;
            }

            function getyyyymm(date) {
                if (typeof date == 'string') {
                    return date.replace('-', '');
                }
                var year = date.getFullYear();
                var month = date.getMonth() + 1;
                return year + (month > 9 ? '' : '0') + month;
            }

        }]);
});

